module.exports = __webpack_public_path__ + "img/it-logo.c953038b.svg";